import { createContext, useState, useContext } from 'react';

type FullscreenContextType = {
  isFullscreen: boolean;
  setIsFullscreen: (value: boolean) => void;
  needFullscreenButton: boolean;
  setNeedFullscreenButton: (value: boolean) => void;
  headerEnabled: boolean;
  setHeaderEnabled: (value: boolean) => void;
  handler: () => void;
  registerClickHandler: (fn: () => void) => void;
};

const FullscreenContext = createContext<FullscreenContextType | undefined>(
  undefined
);

export const FullscreenProvider = ({ children }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [needFullscreenButton, setNeedFullscreenButton] = useState(false);
  const [headerEnabled, setHeaderEnabled] = useState(true);
  const [handler, setHandler] = useState(null);

  const registerClickHandler = (fn) => {
    setHandler(() => fn);
  };

  return (
    <FullscreenContext.Provider
      value={{
        isFullscreen,
        setIsFullscreen,
        needFullscreenButton,
        setNeedFullscreenButton,
        headerEnabled,
        setHeaderEnabled,
        handler,
        registerClickHandler,
      }}
    >
      {children}
    </FullscreenContext.Provider>
  );
};

export const useFullscreen = () => {
  const context = useContext(FullscreenContext);
  // if (!context) throw new Error('useFullscreen must be used internally FullscreenProvider');
  if (!context) {
    return {
      isFullscreen: false,
      setIsFullscreen: () => {},
      needFullscreenButton: false,
      setNeedFullscreenButton: () => {},
      headerEnabled: true,
      setHeaderEnabled: () => {},
      handler: () => {},
      registerClickHandler: () => {},
    };
  }
  return context;
};
